import { Selector } from 'reselect';
import { RootState } from '../../model/Redux';

export const selectIsIOS: Selector<RootState, boolean> = (state) => {
    if (!state.appConfig.data.device) return false;
    return state.appConfig.data.device.platform === 'ios';
};
